class Messages {
    static SESSION_OVER_MESSAGE = "Your session has expired. Please log in again. This can happen if the same account is logged in elsewhere.";
}

export default Messages